document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.custom-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: 'slide', // Puedes cambiar por 'fade', 'cube', 'coverflow', 'flip'
  });
});
